module.exports = __webpack_public_path__ + "img/logo-25.12c8a334.png";